/** Padding inside the hero iframe document so runtime selection chrome can extend past the product frame. */
export const HERO_CANVAS_BLEED_PX = 32;

export function heroCanvasIframePixelSize(
  contentWidth: number,
  contentHeight: number,
): { width: number; height: number } {
  const inset = HERO_CANVAS_BLEED_PX * 2;
  return {
    width: contentWidth + inset,
    height: contentHeight + inset,
  };
}

/** Host-side iframe element geometry (larger than the logical viewport, offset into the bleed pad). */
export function heroCanvasIframeHostStyle(
  contentWidth: number,
  contentHeight: number,
): {
  position: "absolute";
  top: number;
  left: number;
  width: number;
  height: number;
  border: 0;
} {
  const bleed = HERO_CANVAS_BLEED_PX;
  const { width, height } = heroCanvasIframePixelSize(contentWidth, contentHeight);
  return {
    position: "absolute",
    top: -bleed,
    left: -bleed,
    width,
    height,
    border: 0,
  };
}
